/*
 * @Descripttion: 
 * @version: 
 * @Author: TangXihao
 * @Date: 2020-10-12 09:08:12
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2023-06-26 18:40:09
 */
import React, { PureComponent, Fragment, useState } from 'react'
import { Avatar, Col, Row, Input, Tabs, Divider, Pagination, Button, Radio, Badge, Select, message, Checkbox, Dropdown, Menu } from 'antd';
import './index.css'
import addimg from '../../../resources/img/icon_add.png'
// import avatarimg from '../../resources/img/avatar.jpg'
// import moreimg from '../../resources/img/更多操作.png'
// import { UserOutlined, SearchOutlined } from '@ant-design/icons';
import ChatView from './components/ChatView'

import ChatList from './components/ChatList'
import { Link, Route, Switch, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Chat_Friends from './components/FriendsList';
import CustomModal from '../../components/CustomModal/index';
import Axios from 'axios'
// import { saveUserLocal } from '../../service/localstore';
import NewFriend from './components/NewFriendView';
import AddFriend from './components/AddFriendWindow';
import DefaultView from './components/DefaultView';
import AddGroup from './components/AddGroupWindow';
import FindNothing from './components/DefaultView/FindNothing';

import Header4 from '../../../components/Header/Header4';
const { Search } = Input
// **************************************************
// ******   **********   ******************   *******
// ******    *********   *         ********   *******
// *******   **********      ***   **               *
// *               *               **   *   *       *
// *******   **********            ***    *   *     *
// *******   **********            ***  **   ****  **
// *******   *********   *         ***             **
// *******   *********             ***   *   ***   **
// **             ***          *   ***             **
// *******   *******      **     *****             **
// *******   *********   ***     *****   *     *   **
// *******   *********   **      *  **         *   **
// *******   *********   *   *      **   ****      **
// *                **       *      **             **
// *******************     ***********   *******   **
// **************************************************


class ChatWindow extends React.Component {
    state = {
        // activeRoom: null
        tab: 0,
        searchtext: ''
    }

    //打开聊天室
    openChat = (info) => {
        console.log(info)
        // this.chatview.reload()
        this.setState({ activeRoom: info })
    }
    search = ({ target: { value } }) => {
        this.setState({ searchtext: value })
    }
    tabclick = (key) => {
        this.setState({ tab: key })
    }
    onaddfriendclick = () => {
        this.addfriend.show()
    }
    onaddgroupclick = () => {
        this.addroom.show()
    }
    addMenuClick = () => { }
    render() {
        const addchatmenu = (
            <div className='addchatmenu-panel'>
                <div className='addchatmenu-item-panel' onClick={this.onaddgroupclick}>
                    {'新建群组'}
                </div>
                {/* <div style={{ height: 1, backgroundColor: 'rgba(213, 213, 213, 1)', marginLeft: 16, marginRight: 16 }}></div> */}
                <div className='addchatmenu-item-panel' onClick={this.onaddfriendclick}>
                    {'添加好友'}
                </div>
            </div>
        );
        return (
            <>
                <Header4></Header4>
                <div className="chat-background">
                    <div className='chat-main'>
                        {/* 左侧检索  列表栏 */}
                        <div className='chat-left' >
                            {/* 搜索框 */}
                            <div style={{ height: 52, borderBottom: '1px solid rgba(213, 213, 213, 1)', display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
                                {/* <Input onChange={this.search.bind(this)} className='list-searchbox' placeholder={'查找消息'} prefix={<img src={require('../../resources/img/icon-search.png')} />} ></Input> */}
                                <Search className='chat-search common-search' value={this.state.searchtext} onChange={this.search} placeholder='搜索'></Search>
                                <Dropdown trigger='click' className='list-add' overlay={addchatmenu} placement='bottomRight'>
                                    <div>
                                        <img src={addimg} style={{ margin: 7 }}></img>
                                    </div>
                                </Dropdown>
                            </div>
                            {/* 列表选择栏 */}
                            <div className='chat-listtype-tab' >
                                <div className={this.state.tab === 0 ? 'chat-leftpanel-btn chat-leftpanel-btn-active' : 'chat-leftpanel-btn'} onClick={this.tabclick.bind(this, 0)} >
                                    {'消息列表'}
                                </div>
                                <div className={this.state.tab === 1 ? 'chat-leftpanel-btn chat-leftpanel-btn-active' : 'chat-leftpanel-btn'} onClick={this.tabclick.bind(this, 1)} >
                                    {/* <Badge dot={this.props.friendApplication.filter(a => a.validateFlag === '0').length}> */}
                                    {'好友列表'}
                                    {/* </Badge> */}
                                </div>
                            </div>
                            {/* 列表 */}
                            <div style={{ position: 'absolute', bottom: 0, width: '100%', top: '100px' }}>
                                {
                                    this.state.tab == 0 ?
                                        <ChatList searchtext={this.state.searchtext} openChat={this.openChat}></ChatList> :
                                        <Chat_Friends searchtext={this.state.searchtext} history={this.props.history} settotalklist={() => {
                                            this.setState({ tab: 0 })
                                        }}></Chat_Friends>
                                }
                            </div>
                        </div>
                        {/* 内容栏 */}
                        <div className='chat-right-panel'>
                            <Switch>
                                <Route path='/Chat/Room' component={this.props.activeRoom ? ChatView : FindNothing} />
                                <Route path='/Chat/NewFriend' component={NewFriend} />
                                <Route path='/Chat' component={FindNothing} />
                            </Switch>
                        </div>

                        {/* 自定义面板 */}
                        <CustomModal ref={(ref) => { this.addfriend = ref }} className='chat-addfriend-modal'>
                            <AddFriend close={() => {
                                this.addfriend.close()
                            }} user={this.props.user}></AddFriend>
                        </CustomModal>
                        <CustomModal ref={(ref) => { this.addroom = ref }} className='chat-addfriend-modal'>
                            <AddGroup close={() => {
                                this.addroom.close()
                            }} user={this.props.user}></AddGroup>
                        </CustomModal>
                    </div>
                </div>
            </>
        );
    }
}
const mapState = state => ({
    activeRoom: state.userReducer.get('activeRoom'),
    user: state.userReducer.get('user').toJS(),
    friendApplication: state.userReducer.get('friendApplication').toJS(),
})

const mapDispatch = dispatch => ({
})

export default connect(
    mapState,
    mapDispatch
)(ChatWindow)

